/**
 * 将数字转换为印尼货币格式（总是显示货币符号）
 * @param {number|string} value - 输入的值
 * @returns {string} 格式化后的货币字符串
 */
export const formatIndonesianCurrency = (value) => {
  if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
    return 'Rp 0';
  }
  
  // 转换为数字
  const numValue = Number(value);
  
  // 分离整数和小数部分（保留两位小数）
  const [integerPart, decimalPart] = numValue.toFixed(2).split('.');
  
  // 格式化整数部分（添加千位分隔符）
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  // 处理小数部分
  let formattedDecimal = '';
  if (decimalPart) {
    // 如果小数部分都是0，则显示为"-"
    if (parseInt(decimalPart) === 0) {
      formattedDecimal = '';
    } else {
      // 移除末尾的0
      const trimmedDecimal = decimalPart.replace(/0+$/, '');
      if (trimmedDecimal) {
        formattedDecimal = `,${trimmedDecimal}-`;
      } else {
        formattedDecimal = '';
      }
    }
  } else {
    formattedDecimal = '';
  }
  
  return `Rp ${formattedInteger}${formattedDecimal}`;
};

/**
 * Vue过滤器：印尼货币格式化
 * 使用方式：{{ amount | indonesianCurrency }}
 */
export const indonesianCurrencyFilter = {
  install(Vue) {
    Vue.filter('indonesianCurrency', function(value) {
      return formatIndonesianCurrency(value);
    });
  }
};
